import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import { useLocation } from 'react-router-dom';

export default function Contact() {
  const location = useLocation();
  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1)); // Remove the '#' and get the element by ID
      if (element) {
        // Get the element's position relative to the page
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset;
        const offset = 80; // Adjust this value to control the padding from the top (e.g., height of navbar)
        // Scroll to the element with an offset
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
      }
    }
  }, [location]);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    comments: '',
  });

  const [messageSent, setMessageSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const sendEmail = (e) => {
    e.preventDefault(); // Prevent default form submission
    setErrorMessage(''); // Clear any error message

    const { firstName, email, comments } = formData;

    // Check if First Name, Email, and Comments are filled
    if (!firstName || !email || !comments) {
      setErrorMessage('Please fill in all required fields.');
      setMessageSent(false);
      return;
    }

    // Check if the email is valid
    if (!validateEmail(email)) {
      setErrorMessage('Please enter a valid email address.');
      setMessageSent(false);
      return;
    }

    // If validation passes, send the email
    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          to_name: "Evolta",                              // static recipient name
          from_name: formData.firstName + " " + formData.lastName,
          message: formData.comments,
          reply_to: formData.email,                       // sender's email
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setMessageSent(true);
        },
        (error) => {
          console.log(error); // to log error incase of debugging needed
          setErrorMessage(
            `Unknown error occured. Please try again later. error: (${error})`
          );
        }
      );
  };

  return (
    <div className="w-full lg:w-[752px] mx-auto">
      <p id="evolta_contact_form" className="contact-heading">
        Get in touch to learn more about how we can build a clean energy future,
        Together!
      </p>
      <div className="contact-us mt-5 w-full h-auto sm:h-[550px] p-5 sm:p-8 md:p-0 md:py-[48px] md:px-10 bg-white rounded-[20px] border border-grey">
        <form onSubmit={sendEmail}>
          <div className="grid grid-cols-12 gap-5 md:gap-[33px] items-center">
            <div className="col-span-12 md:col-span-6">
              <input
                type="text"
                name="firstName"
                className="w-full h-[52px] border border-grey rounded-lg outline-none f-f-r text-lg text-black pl-[22px]"
                placeholder="First Name (required)"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <input
                type="text"
                name="lastName"
                className="w-full h-[52px] border border-grey rounded-lg outline-none f-f-r text-lg text-black pl-[22px]"
                placeholder="Last Name (required)"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-12 gap-5 md:gap-[33px] items-center mt-5">
            <div className="col-span-12 md:col-span-6">
              <input
                type="text"
                name="company"
                className="w-full h-[52px] border border-grey rounded-lg outline-none f-f-r text-lg text-black pl-[22px]"
                placeholder="Company"
                value={formData.company}
                onChange={handleChange}
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <input
                type="email"
                name="email"
                className="w-full h-[52px] border border-grey rounded-lg outline-none f-f-r text-lg text-black pl-[22px]"
                placeholder="Email (required)"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

          <textarea
            name="comments"
            className="w-full h-auto md:h-[224px] border border-grey rounded-lg outline-none f-f-r text-lg text-black p-[22px] mt-5"
            placeholder="Your Message (required)"
            value={formData.comments}
            onChange={handleChange}
          />

          <button
            className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5"
            type="submit"
          >
            Send Message
          </button>

          {messageSent && (
            <h2 className="pb-4 f-f-r text-black-light text-lg pt-3">
              Thank you for contacting us. We will get back to you soon.
            </h2>
          )}
          {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
}
